import { getAuthHeaders } from '../actions/authActions';
import tempMeeApi from '../apis/tempMee';
import { isSubProfession } from '../components/mainComponents/PermanentJobV2/shared/utils';

export const fetchPermanentJobsList = async (filters, officeId) => {
  const headers = await getAuthHeaders();

  const searchParams = {
    page: filters?.page ? Math.max(filters.page, 1) : 1,
    limit: filters?.limit || 15,
    plan: filters?.plan || undefined,
    recruiter: filters?.recruiter || undefined,
    professionType:
      filters?.professionType && isSubProfession(filters?.professionType)
        ? undefined
        : filters?.professionType,
    subProfession:
      filters?.professionType && isSubProfession(filters?.professionType)
        ? filters?.professionType
        : undefined,
    status: filters?.status || undefined,
    officeName: filters?.officeName || undefined,
    states: filters?.states || undefined,
    jobTitle: filters?.jobTitle || undefined,
    officeId: officeId || undefined,
    sortBy: filters?.sortBy || undefined,
    sortOrder: filters?.sortOrder || undefined,
  };

  const response = await tempMeeApi.get('/posting-service/admin/postings', {
    headers,
    params: {
      page: searchParams.page,
      pageSize: searchParams.limit,
      planId: searchParams.plan,
      recruiterId: searchParams.recruiter,
      profession: searchParams.professionType,
      subProfession: searchParams.subProfession,
      status: searchParams.status,
      search: searchParams.officeName,
      officeState: searchParams.states,
      jobTitle: searchParams.jobTitle,
      officeId: searchParams.officeId,
      orderBy: searchParams.sortBy,
      orderDirection: searchParams.sortOrder,
    },
  });

  return response.data;
};

export const postPermanentJob = async (payload) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post('/recruitment-service/admin/jobs', payload, {
    headers,
  });

  return response.data;
};

export const getJobDetails = async (jobId) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get(`/recruitment-service/admin/jobs/${jobId}`, {
    headers,
  });

  return response.data;
};

export const updateJobDetails = async (jobId, payload) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.patch(`/recruitment-service/admin/jobs/${jobId}`, payload, {
    headers,
  });

  return response.data;
};

export const getJobApplications = async (jobId) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get(`/recruitment-service/admin/jobs/${jobId}/applications`, {
    headers,
  });

  return response.data;
};

export const postJobApplication = async (jobId, payload) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post(
    `/recruitment-service/admin/jobs/${jobId}/applications`,
    payload,
    {
      headers,
    },
  );

  return response.data;
};

export const updateJobApplication = async (jobId, applicationId, payload) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.patch(
    `/recruitment-service/admin/jobs/${jobId}/applications/${applicationId}`,
    payload,
    { headers },
  );

  return response.data;
};

export const getProfessionalResume = async (professionalId) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.get(
    `/recruitment-service/admin/professionals/${professionalId}/resume`,
    {
      headers,
    },
  );

  return response.data;
};

export const updateProfessionalResume = async (professionalId, payload) => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.put(
    `/recruitment-service/admin/professionals/${professionalId}/resume`,
    payload,
    { headers },
  );

  return response.data;
};
